// PrintMenu.js
import { DomEditor } from '@wangeditor/editor'
import { Boot } from '@wangeditor/editor'

class PrintMenu {
  constructor() {
    this.title = '打印'
    this.iconSvg = `<svg viewBox="0 0 1024 1024" width="20" height="20"><path d="M832 384H192a64 64 0 0 0-64 64v256h160v160h448V704h160V448a64 64 0 0 0-64-64zM704 832H320V640h384v192zm64-256H256V448h512v128zm64-448H192V64h640v64z"/></svg>`
    this.tag = 'button'
  }

  getValue(editor) {
    return ''
  }

  isActive(editor) {
    return false
  }

  isDisabled(editor) {
    return false
  }

  exec(editor) {
    const html = editor.getHtml()
    const printFrame = document.createElement('iframe')
    printFrame.style.position = 'fixed'
    printFrame.style.right = '0'
    printFrame.style.bottom = '0'
    printFrame.style.width = '0'
    printFrame.style.height = '0'
    printFrame.style.border = '0'
    document.body.appendChild(printFrame)

    const frameDoc = printFrame.contentWindow.document
    frameDoc.open()
    frameDoc.write(`
      <html>
        <head>
          <title>打印内容</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            img { max-width: 100%; }
          </style>
        </head>
        <body>
          ${html}
        </body>
      </html>
    `)
    frameDoc.close()

    printFrame.onload = () => {
      printFrame.contentWindow.focus()
      printFrame.contentWindow.print()
      setTimeout(() => document.body.removeChild(printFrame), 100)
    }
  }
}

export default PrintMenu
